export default __webpack_public_path__ + "static/media/allTasksCompleted.523df42a.gif";